import React from "react";
import { Route } from "react-router-dom";
import { OrganizationReportCard } from "./OrganizationReportCard";
import { OrganizationReportEditDialog } from "./organization-report-edit-dialog/OrganizationReportEditDialog";
import { OrganizationReportUIProvider } from "./OrganizationReportUIContext";
import { PrivateRoute } from "../../../PrivateRoute";
import { RoleChecker } from "../../../RoleChecker";

export function OrganizationReportPage({ history }) {
  const organizationReportUIEvents = {
    newOrganizationReportButtonClick: () => {
      history.push("/organization-report/new");
    },
    openEditOrganizationReportPage: id => {
      history.push(`/organization-report/${id}/edit`);
    }
  };

  return (
    <OrganizationReportUIProvider
      organizationReportUIEvents={organizationReportUIEvents}
    >
      {/* <PrivateRoute
        // role={RoleChecker("Create", "organizationReport")}
        role={true}
        component={OrganizationReportEditDialog}
        path="/organization-report/new"
      /> */}
      {/* <PrivateRoute
        // role={RoleChecker("Edit", "organizationReport")}
        role={true}
        component={OrganizationReportEditDialog}
        path="/organization-report/:id/edit"
      /> */}

      {/* <Route path="/organization-report/new">
        {({ history, match }) => (
          <OrganizationReportEditDialog
            show={match != null}
            onHide={() => {
              history.push("/organization-report");
            }}
          />
        )}
      </Route> */}

      {/* <Route path="/organization-report/:id/edit">
        {({ history, match }) => (
          <OrganizationReportEditDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/organization-report");
            }}
          />
        )}
      </Route> */}

      <OrganizationReportCard />
    </OrganizationReportUIProvider>
  );
}
